import { Card, Tooltip } from "antd";
import { Surgeon } from "../../../../types/surgeons";
import "./quote-surgeon.css";
import Meta from "antd/es/card/Meta";
import { uploadedImagePath } from "../../../../utils/uploadedImage";
import { useGetSurgeonPriceRange } from "./hooks/useGetSurgeonPriceRange";
import { formatCurrency } from "../../../../utils/currencyFormatter";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useQuote } from "../../QuoteProvider";
import SurgeonMobileListItem from "./SurgeonMobileListItem";
import { useIsMobile } from "../../MobileBreakpointContext";

type QuoteSurgeonProps = {
  surgeon: Surgeon;
  imageOnly?: boolean;
  isDisabled: boolean;
};

const QuoteSurgeon = ({
  surgeon,
  isDisabled,
  imageOnly,
}: QuoteSurgeonProps) => {
  // different from QuoteProvider getSurgeonPricing because the surgeon is not selected
  const { maxPrice, minPrice } = useGetSurgeonPriceRange({
    selectedSurgeon: surgeon,
  });

  const quoteData = useQuote();
  const isSelected = quoteData.selectedSurgeon?.id === surgeon.id;

  const isMobile = useIsMobile();

  const surgeonElement = !isMobile ? (
    <Card
      className={isSelected ? "quote-surgeon-selected" : ""}
      hoverable
      cover={
        <img
          style={{
            height: "230px",
            objectFit: "cover",
            objectPosition: "top",
          }}
          alt="surgeon image"
          src={uploadedImagePath(surgeon.image)}
          loading="lazy"
          decoding="async"
        />
      }
    >
      <Meta title={surgeon.name} description={surgeon.nickname} />
      {!imageOnly && (
        <div style={{ paddingTop: "10px" }}>
          {isDisabled ? (
            "--"
          ) : (
            <div>
              {quoteData.selectedSurgeon && (
                <div>{/* From: <b>{formatCurrency(minPrice)}</b> */}</div>
              )}
            </div>
          )}
        </div>
      )}
    </Card>
  ) : (
    <SurgeonMobileListItem
      surgeon={surgeon}
      isSelected={isSelected}
      isDisabled={isDisabled}
      imageUrl={surgeon.image}
      imageOnly={imageOnly}
      minPrice={minPrice}
      quoteData={quoteData}
    />
  );

  return (
    <span
      className="quote-surgeon"
      style={{
        opacity: isDisabled ? "0.4" : "1",
        height: imageOnly ? "200px" : "auto",
      }}
    >
      {surgeonElement}
    </span>
  );
};

export default QuoteSurgeon;
